import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  messagesOverlay: {
    backgroundImage: `linear-gradient(transparent, ${theme.vars.palette.background.elevation2} 60%)`,
    position: 'absolute',
    bottom: 0,
    height: '50%',
    width: '100%',
    zIndex: 900
  },
  messagesViewButton: {
    cursor: 'pointer',
    display: 'flex',
    fontWeight: 700,
    justifyContent: 'center',
    marginTop: '3rem',
    position: 'relative',
    textAlign: 'center',
    zIndex: 1000
  },
  messagesViewButtonText: {
    display: 'flex',
    whiteSpace: 'pre-wrap',
    '&.viewLessButton': {
      alignItems: 'end'
    },
    '&.viewMoreButton': {
      alignItems: 'start'
    }
  }
}));

export default useStyles;
